<template>
    <div class="map-wrapper" :class="userDevice">
        <template v-if="userDevice !== 'mobile'">
            <div class="sub-title">
                한반도의 공룡과 함께 하는 코딩 게임
            </div>
            <div class="main-title">
                점박이와 코딩을!
            </div>
            <a class="video" href="/coding/jbCodingView.do?type=VOD2" target=”_blank”>
                동영상 보기
            </a>
            <div class="tag-wrapper">
                <div
                    v-for="(tag, i) in tags"
                    :key="i"
                    class="tag"
                    v-text="`#${tag}`"
                />
            </div>
            <div class="count">
                지금까지 {{userCount}}명이 온라인 코딩 파티에 참여했어요!
            </div>
            <div class="btn-wrapper">
                <div
                    v-for="(btn, i) in btns"
                    :key="i"
                    class="btn"
                    :class="{ big: btn.big, clear: btn.claer, doing: btn.doing }"
                    :style="{ top: `${btn.top}px`, left: `${btn.left}px` }"
                    v-html="btn.claer || btn.doing ? i + 1 : ''"
                    @click="toMission(btn.cat, btn.claer || btn.doing)"
                />
            </div>
            <div class="desc-wrapper">
                <div
                    class="desc"
                    style="top: 910px; left: 300px"
                >
                    <div class="text">
                        사냥터에 가고 싶은 막내,<br>
                        막내와 만나 사냥터로 이동하세요!
                    </div>
                </div>
                <div
                    class="desc"
                    style="top: 1310px; left: 525px"
                >
                    <div class="text">
                        막내가 납치됐어요!<br>
                        납치된 막내의 흔적을 찾아보아요!
                    </div>
                </div>
                <div
                    class="desc"
                    style="top: 1775px; left: 525px"
                >
                    <div class="text">
                        알을 훔치려는 랩터를 피해<br>
                        알을 모두 모아주세요!
                    </div>
                </div>
                <button
                    class="certi"
                    :class="{ active: certActiveBasic }"
                    style="top: 1135px; left: 900px"
                    @click="certiBasic"
                >
                    기초 인증서
                </button>
                <button
                    class="certi"
                    :class="{ active: certActiveDeep }"
                    style="top: 1507px; left: 900px"
                    @click="certiDeep"
                >
                    심화 인증서
                </button>
                <button
                    class="certi"
                    :class="{ active: certActiveComplete }"
                    style="top: 2439px; left: 275px"
                    @click="certiComplete"
                >
                    완성 인증서
                </button>
            </div>


            <template v-if="isShowModal">
                <div class="modal-bg" />
                <modal @close="isShowModal = false" />
            </template>
            <template v-if="isShowModal2">
                <div class="modal-bg" />
                <modal2 @close="isShowModal2 = false" />
            </template>

            <map-info-input-template
                v-if="isNonUserInfo"
                @saveUser="saveUser"
                :userDevice="userDevice"
                :courseCat="courseCat"
                :showCertPopup="showCertPopup"
            />
        </template>
        <template v-else>
            <img src="../../assets/images/jb/mobile_bg.png" class="mobile-bg" @click="isShowModal4 = true">
            <modal4 v-if="isShowModal4" @close="isShowModal4 = false" />
        </template>
        <win-popup ref="winPopup" @onClose="val => evtCloseWinPopup(val)" @onRecvEvtFromWinPop="val => onRecvWinPop(val)" />
    </div>
</template>

<script>
import mobileDetect from 'mobile-detect'
import { axios, was } from '@/lib/axios';

import Modal from './Modal';
import Modal2 from './Modal2';
import Modal4 from './Modal4';
import mapInfoInputTemplate from '../map/MapInfoInputPopup'
import WinPopup from '../WinPopup';

export default {
    components: {
        Modal,
        Modal2,
        Modal4,
        mapInfoInputTemplate,
        WinPopup,
    },
    data() {
        return {
            tags: ['블록코딩 언어 활용', '코딩 기초 개념 습득', '교육과정 연계 학습 콘텐츠'],
            missions: [
                [
                    {
                        top: 715,
                        left: 293
                    },
                    {
                        top: 715,
                        left: 526
                    },
                    {
                        top: 727,
                        left: 772
                    },
                    {
                        top: 908,
                        left: 858
                    },
                    {
                        top: 1103,
                        left: 752
                    }
                ],
                [
                    {
                        top: 1117,
                        left: 521
                    },
                    {
                        top: 1213,
                        left: 321
                    },
                    {
                        top: 1434,
                        left: 337
                    },
                    {
                        top: 1506,
                        left: 548
                    },
                    {
                        top: 1531,
                        left: 774
                    }
                ],
                [
                    {
                        top: 1730,
                        left: 868
                    },
                    {
                        top: 1887,
                        left: 717
                    },
                    {
                        top: 1896,
                        left: 484
                    },
                    {
                        top: 2058,
                        left: 332
                    },
                    {
                        top: 2291,
                        left: 332
                    }
                ]
            ],
            isShowModal: false,
            isShowModal2: false,
            isShowModal3: false,
            isShowModal4: false,
            isShowModal5: false,
            userDevice: 'pc',
            courseCat: 'ESOF03',
            isLoading: false,
            lbcookie: '',
            isNonUserInfo: false,
            userCount: localStorage.getItem('party_user_count_3') || 0,
            certTy: 1
        };
    },
    computed: {
        btns() {
            let prev;
            return this.missions.reduce((a, b, i1) => {
                b.forEach((e, i2) => {
                    e.cat = `ESOF03_1_${i1 + 1}_${i2 + 1}`;
                    e.doing = !e.claer && (!prev || (prev && prev.claer));
                    prev = e;
                });
                a.push(...b);
                return a;
            }, []);
        },
        certActiveBasic() {
            return this.btns[4].claer;
        },
        certActiveDeep() {
            return this.btns[9].claer;
        },
        certActiveComplete() {
            return this.btns[this.btns.length - 1].claer;
        }
    },
    async mounted() {
        this.publicIP = await this.getClientIP();

        if (typeof parent.codingPartyCnt === 'function') {
            parent.codingPartyCnt(this.userCount)
        }

        // 학습 참가자수
        axios.get(`/coding-party/count3?${this.randomId()}`)
            .then(res => {
                this.userCount = this.addComma(res.data)
                localStorage.setItem('party_user_count_3', this.userCount);

                if (typeof parent.codingPartyCnt === 'function') {
                    parent.codingPartyCnt(this.userCount)
                }
            })

        const MD = new mobileDetect(window.navigator.userAgent);
        if (MD.tablet() !== null) {
            this.userDevice = 'tablet';
            await this.init();
        } else if (MD.mobile() !== null) this.userDevice = 'mobile';
        else await this.init();
    },
    methods: {
        addComma(num) {
            if (num === null || isNaN(num)) return num
            if ((num + '').indexOf('.') > -1) num = num.toFixed(3)
            return (num + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
        setCookie(obj, hours = 3) {
          try{
            let date = new Date();

            date.setTime(date.getTime() + (hours * 3600 * 1000));

            let expires = "expires=" + date.toGMTString() +";";
            //let expires = "expires=" + date.toGMTString() +";"; // toGMTString 안되면 toUTCString 사용하여 테스틑 해볼것

            for (let key in obj) {
              // Ver1(코딩파티2018년버전)
              // document.cookie = `${key}=${obj[key]}; path=/; expires=Thur, 31 Dec 2099 23:59:59 UTC;`;  // 쿠키 만료 시간 무제한

              // Ver2(코딩파티2019년버전)
              let cookieString = `${key}=${obj[key]}; path=/; ${expires}`;
              document.cookie = cookieString;  // 쿠키 만료 시간(3시간)
              //console.log(`[Cookie] String >> ${cookieString}`);
            }
          }catch(e){
            console.log(`[Cookie] Exception : ${JSON.stringify(e)}`);
          }
        },
        async init() {
            await was
                .post(
                    `${this.API_SERVER_URL}/manage/codmos/user/party_init`,
                    {},
                )
                .then(async (response) => {
                    if (response.status === 200) {
                        if (response.data.code === "1000") {
                            if (response.data.trialLoginUser) {
                                this.lbcookie = response.data.trialLoginUser;
                                this.setCookie({
                                    userType: 'party',
                                    loginUserInfo: JSON.stringify({
                                        lbparty: this.lbcookie,
                                    }),
                                    publicIP: this.publicIP,
                                    isLogin: true
                                }, 9e9)
                            }
                        } else {
                            const userInfo = JSON.parse(this.getCookie('jbNonLoginUserInfo') || '{}');
                            if (userInfo) {
                                this.lbcookie = userInfo.lbparty;
                            }

                            this.setCookie({
                                isLogin: false
                            })
                            if (!this.lbcookie) {
                                this.isNonUserInfo = true;
                            }
                        }
                        if (this.lbcookie) {
                            this.isLoading = true;
                            await this.setClearData();
                        }
                    }
                })
                .catch(e => {
                    console.error(e)
                });
        },
        async setClearData() {
            const res = await axios.get(
                `${this.API_SERVER_URL}/manage/codmos/record/party/ESOF03/1/0/0?${this.randomId()}`,
                { headers: { lbcookie: this.lbcookie } }
            );

            if (
                res.data.code === '1000'
                && Array.isArray(res.data.docs)
            ) {
                res.data.docs.filter(e => e.isCleared).forEach(e => {
                    if (
                        this.missions[e.stageCat - 1]
                        && this.missions[e.stageCat - 1][e.missionCat - 1]
                    ) {
                        this.$set(this.missions[e.stageCat - 1][e.missionCat - 1], 'claer', true)
                    }
                });
            } else {
                document.cookie.split(';').forEach((c) => {
                    document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
                });

                alert('유저 정보가 올바르지 않습니다.');

                location.reload();
            }
        },
        async toMission(cat, open) {
            if (this.isLoading) {
                if (open) {
                    window.top.open(`/codmos/study/${cat}?type=trial`, '_blank');
                } else {
                    this.isShowModal2 = true;
                }
            } else {
                this.isShowModal = true;
            }
        },
        certiBasic() {
            if (this.certActiveBasic) {
                this.certTy = 'basic';
                if (this.getCookie('isLogin') === 'true') {
                    this.isNonUserInfo = true;
                } else {
                    this.showCertPopup();
                }
            }
        },
        certiDeep() {
            if (this.certActiveDeep) {
                this.certTy = 'deep';
                if (this.getCookie('isLogin') === 'true') {
                    this.isNonUserInfo = true;
                } else {
                    this.showCertPopup();
                }
            }
        },
        certiComplete() {
            if (this.certActiveComplete) {
                this.certTy = 'complete';
                if (this.getCookie('isLogin') === 'true') {
                    this.isNonUserInfo = true;
                } else {
                    this.showCertPopup();
                }
            }
        },
        showCertPopup() {
            this.popupUri = new URL(`${location.origin}/codmos/jb/certificate`);
            const popup = this.$refs.winPopup.openWinPop(this.popupUri, 1200, 750);
            popup.onload = () => {
                if (g_winPopup)  {
                    this.$refs.winPopup.sendEvtToChild({ certTy: this.certTy });
                }
            }
        },
        saveUser(req) {
            this.isNonUserInfo = false;
            this.isLoading = true;
            if (req.showCertPopup) {
                req.showCertPopup();
            }
        },
        async getClientIP() {
            return (await axios.get('https://jsonip.com')).data.ip;
        },
    }
}
</script>

<style>
    html, body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
    }
</style>

<style lang="scss" scoped>
    .video {
        position: absolute;
        width: 186.4px;
        height: 58px;
        left: 549px;
        top: 444px;
        color: #fff;
        font-family: NanumSquareB;
        background: url('../../assets/images/jb/btn_video.png') no-repeat;
        background-size: contain;
        text-decoration: none;
        font-size: 19px;
        padding: 15px 0 0 52px;
        box-sizing: border-box;
    }

    .map-wrapper {
        width: 1280px;
        &.pc, &.tablet {
            height: 2993px;
        }
        background: url('../../assets/images/jb/bg.png') no-repeat;
        margin: auto;
        position: relative;
        > * {
            z-index: 1;
        }
    }

    .tag-wrapper {
        display: inline-block;
        font-family: 'NanumSquareB', sans-serif;
        font-size: 18px;
        letter-spacing: -.5px;
        color: #0097a3;
        position: absolute;
        top: 281px;
        left: 329px;
        width: 623px;
        height: 53px;
        border-radius: 50px;
        line-height: 55px;
        font-weight: 500;

        .tag {
            display: inline-block;
            margin-right: 15px;
            &:last-child {
                margin-right: 0;
            }
        }
    }

    .count {
        position: absolute;
        font-family: 'NanumSquareEB', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #fff;
        width: 618px;
        height: 54px;
        border-radius: 27px;
        background: rgba(56, 81, 201, 0.9);
        top: 363px;
        left: 338px;
        line-height: 54px;
    }

    .btn-wrapper {
        position: relative;
        z-index: 2;
        top: 0;
        left: 0;

        .btn {
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
            font-family: yg-jalnan;
            font-size: 24px;
            color: #53402A;
            background: url('../../assets/images/jb/btn_off.png') no-repeat;
            background-size: contain;
            width: 120px;
            height: 120px;
            line-height: 45px;
            &.clear {
                background: url('../../assets/images/jb/btn.png') no-repeat;
                background-size: contain;
                line-height: 100px;
            }
            &.doing {
                background: url('../../assets/images/jb/btn_doing.png') no-repeat;
                background-size: contain;
                width: 147px;
                height: 147px;
                margin-top: calc(-27px / 2);
                margin-left: calc(-27px / 2);
                line-height: 127px;

                &::before {
                    content: '';
                    position: absolute;
                    width: 161px;
                    height: 146px;
                    background: url(../../assets/images/jb/doing_jb.png) no-repeat;
                    background-size: contain;
                    bottom: 105px;
                    left: -8px;
                }
            }
        }
    }

    .desc-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        .desc {
            position: absolute;
            top: 0;
            left: 0;
            min-width: 300px;
            .text {
                color: #fff;
                font-family: NanumSquareB;
                font-weight: 600;
                font-size: 19px;
                line-height: 40px;
                margin-top: -20px;
                border-radius: 20px;
            }
        }
    }

    .modal-bg {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .logo {
        position: absolute;
        bottom: 70px;
        left: 200px;
    }

    .certi {
        position: absolute;
        width: 243px;
        height: 80px;
        font-family: NanumSquareB;
        font-size: 27px;
        color: #fff;
        background: url('../../assets/images/jb/btn_cert_off.png') no-repeat;
        background-size: contain;
        outline: none;
        border: none;
        box-sizing: border-box;
        padding-left: 65px;
        cursor: pointer;
        &.active {
            background: url('../../assets/images/jb/btn_cert.png') no-repeat;
            background-size: contain;
        }
    }


    .mobile-bg {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 999;
    }

    .sub-title {
        font-family: NanumSquareB;
        font-size: 23px;
        position: absolute;
        top: 136px;
        left: 493px;
        color: #000;
    }
    .main-title {
        font-family: yg-jalnan;
        font-size: 64px;
        position: absolute;
        top: 179px;
        left: 396px;
        color: #0097a3;
    }
</style>




// WEBPACK FOOTER //
// src/components/jb/MapCodingParty.vue